export default "__VITE_ASSET__OopkDqj0__"